const C = require("../constants");

const waiterDialog = (data) => {
    return {
        type: C.WAITER_DIALOG,
        data
    }
};

export {waiterDialog};


// WEBPACK FOOTER //
// ./src/actions/WaiterDialogActions.js